<imv-ui-upload-image [showErrors]="showErrors">
	<ng-content></ng-content>
</imv-ui-upload-image>
